import React, { useState, useEffect } from 'react';
import { useAccount, useBalance, useContractRead, useContractWrite, useNetwork, usePrepareContractWrite } from 'wagmi';
import { ethers } from 'ethers';
import { FaGift } from 'react-icons/fa';
import { useSearchParams } from 'react-router-dom';
import tokenABI from '../abis/tokenABI.json';
import airdropABI from '../abis/airdropABI.json';

const ClaimPage = () => {
  const [searchParams] = useSearchParams();
  const referrer = searchParams.get('ref') || ethers.constants.AddressZero;
  const [errorMessage, setErrorMessage] = useState('');
  const { address, isConnected } = useAccount();
  const { chain } = useNetwork();
  
  const TOKEN_CONTRACT = '0x68CFD74de038Acbccf8D3EEF828b506fc361FF28'; // Replace with your token contract address
  const AIRDROP_CONTRACT = '0xA65eDe3E4EECC1786CA9675F7f2b6621a918190D'; // Replace with your airdrop contract address
  const REQUIRED_BNB_FOR_CLAIM = 0.005; // BNB required for claim

  // Get BNB balance
  const { data: bnbBalance } = useBalance({
    address,
    watch: true,
  });

  // Get claimable amount
  const { data: claimableAmount } = useContractRead({
    address: AIRDROP_CONTRACT,
    abi: airdropABI,
    functionName: 'getClaimableAmount',
    args: [address],
    enabled: isConnected && address !== undefined,
  });

  // Prepare claim transaction
  const { config: claimConfig, error: claimPrepareError } = usePrepareContractWrite({
    address: AIRDROP_CONTRACT,
    abi: airdropABI,
    functionName: 'claimAirdrop',
    args: [referrer],
    value: ethers.utils.parseEther('0.005'),
    enabled: isConnected && bnbBalance && parseFloat(ethers.utils.formatEther(bnbBalance?.value || '0')) >= REQUIRED_BNB_FOR_CLAIM,
  });

  // Execute claim transaction
  const { write: claimBadge, isLoading: isClaimLoading, isSuccess: isClaimSuccess } = useContractWrite(claimConfig);

  // Check if BNB balance is sufficient
  useEffect(() => {
    if (isConnected && bnbBalance) {
      const bnbBalanceInEth = parseFloat(ethers.utils.formatEther(bnbBalance.value));
      if (bnbBalanceInEth < REQUIRED_BNB_FOR_CLAIM) {
        setErrorMessage(`Insufficient BNB balance. You must hold at least ${REQUIRED_BNB_FOR_CLAIM} BNB.`);
      } else {
        setErrorMessage('');
      }
    }
  }, [bnbBalance, isConnected]);

  // Handle claim button click
  const handleClaim = () => {
    if (!isConnected) {
      return;
    }

    if (parseFloat(ethers.utils.formatEther(bnbBalance?.value || '0')) < REQUIRED_BNB_FOR_CLAIM) {
      setErrorMessage(`Insufficient BNB balance. You must hold at least ${REQUIRED_BNB_FOR_CLAIM} BNB.`);
      return;
    }

    claimBadge?.();
  };

  return (
    <div className="claim-page">
      <div className="claim-header">
        <FaGift className="claim-icon" />
        <h1 className="claim-title">Claim SONUS TOKEN</h1>
      </div>
      
      <p className="claim-description">
        Claim the Sonus x Soneium Ecosystem SONUS . If you participated in the Sonus x Soneium 
        Ecosystem SONUS  event, you can claim your SONUS  airdrop here.
      </p>
      
      <div className="claim-card">
        <div className="available-claim">
          <p className="available-text">Available to claim</p>
          <h2 className="token-amount">1.200,00</h2>
          <p className="token-symbol">SxS Eco SONUS </p>
        </div>
        
        <button 
          className="wallet-button" 
          onClick={handleClaim}
          disabled={!isConnected || isClaimLoading}
        >
          {!isConnected ? 'Wallet not connected' : 
            isClaimLoading ? 'Claiming...' : 'Claim SONUS'}
        </button>
        
        {errorMessage && <p className="error-message">{errorMessage}</p>}
      </div>
      
      {isConnected && (
        <div className="referral-card">
          <h3 className="referral-title">Refer Friends & Earn</h3>
          <p className="referral-description">
            Share your referral link and earn 99% of BNB and 100% of tokens from your referrals.
          </p>
          
          <div className="referral-input-container">
            <input 
              type="text" 
              className="referral-input" 
              value={`${window.location.origin}/?ref=${address}`} 
              readOnly 
            />
            <button 
              className="copy-button"
              onClick={() => {
                navigator.clipboard.writeText(`${window.location.origin}/?ref=${address}`);
              }}
            >
              Copy
            </button>
          </div>
          
          <div className="referral-stats">
            <div className="referral-stat">
              <p className="stat-label">Total Referrals</p>
              <p className="stat-value">0</p>
            </div>
            <div className="referral-stat">
              <p className="stat-label">BNB Earned</p>
              <p className="stat-value">0 BNB</p>
            </div>
            <div className="referral-stat">
              <p className="stat-label">Tokens Earned</p>
              <p className="stat-value">0 SxS</p>
            </div>
          </div><br></br>
          <p className="referral-description">
            Official Contract: 0x68CFD74de038Acbccf8D3EEF828b506fc361FF28
          </p>
        </div>
      )}
    </div>
  );
};

export default ClaimPage;